import React, { useState, useEffect } from 'react';
import { getUsedAddressArea } from "../../service/AddressApi";  // Adjust this import path
import { queryFamiliesByArea } from "../../service/FamilyQueryApi";  // Adjust this import path for your API call
import '../general/General.css';
import { useCheckAccess, shortenKootam, getSubareaNameTamil } from "../../utils/Utilities";
import { Loading } from "../../components/shared";
import { useSelector } from "react-redux";
const FamilyAreaWiseListContactPrint = () => {
  useCheckAccess('FamilyAdmin');
  const user = useSelector((state) => state.user);
  const [areas, setAreas] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrictTamil, setSelectedDistrictTamil] = useState('');
  const [districtIds, setDistrictIds] = useState([]); // New state for district_tamil IDs
  const [blocks, setBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState('');
  const [subareas, setSubareas] = useState([]); // New state for subareas
  const [selectedId, setSelectedId] = useState(''); // State to hold selected area ID
  const [selectedSubareaId, setSelectedSubareaId] = useState(''); // State to hold selected subarea ID
  const [families, setFamilies] = useState([]);  // State for families data
  const [loading, setLoading] = useState(false); // Loading state for the API request
  const [loadingAreas, setLoadingAreas] = useState(false);
  const [printMode] = useState(true);
  const [paperSize, setPaperSize] = useState('A4');
  const [orientation, setOrientation] = useState('landscape');
  const [extraCols,] = useState(0);
  // Pagination state
  const [pageNumber, setPageNumber] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const formatAddress = (...parts) => parts.filter(Boolean).join(', ');
  const [fetchFullList, setFetchFullList] = useState(false);




  // Fetch areas from API
  const fetchAreas = async () => {
    setLoadingAreas(true);  // Disable the button
    try {
      const response = await getUsedAddressArea();
      if (Array.isArray(response.addressAreaList)) {
        setAreas(response.addressAreaList);
      } else {
        alert("Unexpected area response format");
      }
    } catch (error) {
      console.error("Error fetching areas:", error);
      alert("Failed to fetch area data: " + error.message);
    } finally {
      setLoadingAreas(false);  // Re-enable the button
    }
  };

  // Inside your component:
  useEffect(() => {
    if (areas.length > 0) {
      const tamilNaduDistricts = areas
        .filter(area => area.state_tamil.replace(/\s/g, '') === 'தமிழ்நாடு')
        .map(area => ({
          district_tamil: area.district_tamil,
          district_tamil_display: area.district_tamil
        }));

      const otherStateDistricts = areas
        .filter(area => area.state_tamil.replace(/\s/g, '') !== 'தமிழ்நாடு')
        .map(area => ({
          district_tamil: area.district_tamil,
          district_tamil_display: `${area.district_tamil} (${area.state_tamil})`
        }));

      const combined = [...tamilNaduDistricts, ...otherStateDistricts];

      // Remove duplicates by `district_tamil`
      const uniqueMap = new Map();
      combined.forEach(item => {
        if (!uniqueMap.has(item.district_tamil)) {
          uniqueMap.set(item.district_tamil, item);
        }
      });

      const uniqueDistricts = Array.from(uniqueMap.values());

      setDistricts(uniqueDistricts); // each with { district_tamil, district_tamil_display }
    }
  }, [areas]);



  // Update district_tamil IDs when a district_tamil is selected
  const handleDistrictChange = (e) => {
    setPageNumber(1);
    const district_tamil = e.target.value;
    setSelectedDistrictTamil(district_tamil);

    // Set the available area IDs for the selected district_tamil
    const filteredAreas = areas.filter(area => area.district_tamil === district_tamil);
    const uniqueBlocks = [...new Set(filteredAreas.map(area => area.block_tamil))];
    setBlocks(uniqueBlocks);

    // Reset subareas when district_tamil changes
    setSelectedBlock('');
    setDistrictIds([]);
    setSubareas([]);
    setSelectedId('');
    setSelectedSubareaId('');
  };
  const handleBlockChange = (e) => {
    const block = e.target.value;
    setSelectedBlock(block);
    setPageNumber(1);

    const filteredAreas = areas.filter(
      area => area.district_tamil === selectedDistrictTamil && area.block_tamil === block
    );

    const areaIds = filteredAreas.map(area => area.id);
    setDistrictIds(areaIds);

    setSelectedId('');
    setSubareas([]);
    setSelectedSubareaId('');
  };


  // Update subareas when an area ID is selected
  const handleIdChange = (e) => {
    setPageNumber(1);
    const id = e.target.value;
    setSelectedId(id);

    // Find the selected area by ID and update the subareas
    const selectedArea = areas.find(area => area.id === id);
    if (selectedArea && selectedArea.subAreas) {
      setSubareas(selectedArea.subAreas);  // Update subareas for the selected area
    } else {
      setSubareas([]);  // If no subareas found, reset subareas
    }
  };

  // Handle Subarea selection
  const handleSubareaChange = (e) => {
    setPageNumber(1);
    const subareaId = e.target.value;
    setSelectedSubareaId(subareaId);
  };

  // Submit the selected area and subarea IDs to the Family Enquiry API
  const handleSubmit = async () => {
    if (!selectedDistrictTamil && !selectedId && selectedSubareaId) {
      alert("Cannot query with only Subarea selected.");
      return;
    }

    // Prepare API parameters dynamically
    const queryParams = {
      pageNumber: 1,
      pageSize: 10000
    };
    if (fetchFullList) {
      queryParams.fetchFullList = true;
    } else {
      if (selectedDistrictTamil) {
        queryParams.district = selectedDistrictTamil;
      }
      if (selectedBlock) {
        queryParams.block = selectedBlock;
      }
      if (selectedId) {
        queryParams.areaId = selectedId;
      }
      if (selectedSubareaId) {
        queryParams.subareaId = selectedSubareaId;
      }
    }

    setLoading(true);
    try {
      await fetchAreas();
      const response = await queryFamiliesByArea(queryParams);

      if (response && response.families && Array.isArray(response.families)) {
        const activeFamilies = response.families.filter(fam => fam.status !== 'inactive');
        setTotalItems(activeFamilies.length); // Update total items accordingly
        setFamilies(activeFamilies);
      } else {
        alert("No families found.");
        setFamilies([]);
      }
    } catch (error) {
      console.error("Error fetching families:", error);
      setFamilies([]);
      //setTempFamilies([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDistrictTamil || selectedBlock || selectedId || selectedSubareaId) {
      handleSubmit();
    }
  }, [printMode, pageNumber]);
  const generatePrintableTables = () => {
    const combinedList = [...families];

    // Address-based sorting (matches generateGroupDetailedIndexHtml)
    combinedList.sort((a, b) => {
      const districtCompare = (a.permanentAddressDistrict_tamil || '').localeCompare(b.permanentAddressDistrict_tamil || '', 'ta');
      if (districtCompare !== 0) return districtCompare;

      const blockCompare = (a.permanentAddressBlock_tamil || '').localeCompare(b.permanentAddressBlock_tamil || '', 'ta');
      if (blockCompare !== 0) return blockCompare;

      const postCompare = (a.permanentAddressName_tamil || '').localeCompare(b.permanentAddressName_tamil || '', 'ta');
      if (postCompare !== 0) return postCompare;

      const pinCompare = parseInt(a.permanentPincode || '') - parseInt(b.permanentPincode || '');
      if (pinCompare !== 0) return pinCompare;

      return Number(a.id) - Number(b.id);
    });

    const grouped = groupFamiliesByAddress(combinedList);
    const allPagesHtml = [];
    const groupPageMap = {};
    let currentPage = 1;

    Object.entries(grouped).forEach(([groupKey, groupFamilies]) => {
      groupFamilies.sort((a, b) => Number(a.id) - Number(b.id));
      groupPageMap[groupKey] = currentPage;

      const rows = [];
      // Change loop increment back to 2
      for (let i = 0; i < groupFamilies.length; i += 2) {
        const family1 = groupFamilies[i];
        const family2 = groupFamilies[i + 1];

        // Family 1 details
        let kootam1 = shortenKootam(family1.kootamName, family1.customGroup);
        kootam1 += family1.keyContact ? ' ★' : '';
        //const fullName1 = `${family1.familyHeadFirstName} ${family1.familyHeadLastName}`;
        const fullName1 = `${family1.familyHeadFirstName} ${family1.familyHeadLastName} ` + (family1.familyName ? ` (${family1.familyName})` : '');
        const mobile1 = family1.familyHeadMobile + (family1.familyHeadMobile2 ? ` / ${family1.familyHeadMobile2}` : '');
        let headWithMobile1 = `${fullName1} (${mobile1})`;
        if (family1.tempAddressAreaId) {
          const tempAddressParts = [
            getSubareaNameTamil(family1.tempAddressAreaId, family1.tempSubareaId, areas),
            family1.tempAddressName_tamil,
            family1.tempAddressBlock_tamil,
            family1.tempAddressDistrict_tamil
          ];
          const uniqueParts = [...new Set(tempAddressParts.filter(Boolean))];
          const tempAddress = formatAddress(...uniqueParts);
          headWithMobile1 += `<br/> T: ${tempAddress}`;
        }
        if (family1?.familyOrigin) {
          headWithMobile1 += ' பூ: ' + family1.familyOrigin;
        }
        // Family 2 details
        let kootam2 = '';
        let headWithMobile2 = '';
        if (family2) {
          kootam2 = shortenKootam(family2.kootamName, family2.customGroup);
          kootam2 += family2.keyContact ? ' ★' : '';
          //const fullName2 = `${family2.familyHeadFirstName} ${family2.familyHeadLastName}`;
          const fullName2 = `${family2.familyHeadFirstName} ${family2.familyHeadLastName} ` + (family2.familyName ? ` (${family2.familyName})` : '');
          const mobile2 = family2.familyHeadMobile + (family2.familyHeadMobile2 ? ` / ${family2.familyHeadMobile2}` : '');
          headWithMobile2 = `${fullName2} (${mobile2})`;
          if (family2.tempAddressAreaId) {
            const tempAddressParts = [
              getSubareaNameTamil(family2.tempAddressAreaId, family2.tempSubareaId, areas),
              family2.tempAddressName_tamil,
              family2.tempAddressBlock_tamil,
              family2.tempAddressDistrict_tamil
            ];
            const uniqueParts = [...new Set(tempAddressParts.filter(Boolean))];
            const tempAddress = formatAddress(...uniqueParts);
            headWithMobile2 += `<br/> T: ${tempAddress}`;
          }
        }
        if (family2?.familyOrigin) {
          headWithMobile2 += ' பூ: ' + family2.familyOrigin;
        }

        // Revert the row structure to 2 families
        rows.push(`
          <tr>
            <td>${family1.id} ${kootam1}</td>
            <td>${headWithMobile1}</td>
            <td>${family2?.id ? `${family2.id} ${kootam2}` : ''}</td>
            <td>${headWithMobile2}</td>
          </tr>
        `);
        currentPage++;
      }

      // Revert colspan to 4
      const groupHeaderRow = `
        <tr>
          <td colspan="${4 + extraCols}" style="font-weight: bold; background-color: #eee;">
            ${groupKey} - (${groupFamilies.length})
          </td>
        </tr>`;

      const tableHtml = `
        <table class="print-table">
          <tbody>
            ${groupHeaderRow}
            ${rows.join('\n')}
          </tbody>
        </table>
      `;

      allPagesHtml.push(tableHtml);
    });

    return {
      html: allPagesHtml.join(''),
      groupPageMap
    };
  };
  const generateFrontPageHtml = () => {
    return `
      <div class="front-page">
        <div style="text-align: center; margin-top: 1cm;">
          <h1 style="margin-bottom: 0;">௳</h1>
        </div>
        <div style="text-align: center; margin-top: 1cm;">
          <h2>ஸ்ரீ பொன்னாச்சி அம்மன் துணை !</h2>
          <h2>ஸ்ரீ கருமலையான் துணை !</h2>
        </div>
        <div style="text-align: center; margin-top: 2cm;">
          <h1>அருள்மிகு ஸ்ரீ பெரிய பொன்னாச்சி அம்மன்</h1>
          <h1>அருள்மிகு ஸ்ரீ சின்ன பொன்னாச்சி அம்மன்</h1>
          <h1>திருக்கோவில்கள்</h1>
        </div>
        <div style="text-align: center; margin-top: 2cm;">
          <h2>செம்பூத்தான், மணியன், முத்தன் குலம் குடிப்பாட்டு பட்டியல்</h2>
        </div>
        <div style="text-align: center; margin-top: 3cm; font-size: 14px;">
          <p>🌐 <strong>தள முகவரி:</strong> <a href="https://sriponnachiammantemples.in" target="_blank">sriponnachiammantemples.in</a></p>
          <p>📞 <strong>தொலைபேசி எண்:</strong> 9943475494</p>
        </div>
        <div style="page-break-after: always;"></div>
      </div>
    `;
  };

  const generateGroupDetailedIndexHtml = (groupPageMap) => {
    const sortedEntries = Object.entries(groupPageMap)
      .map(([key, pageNum]) => {
        const parts = key.split(',').map(part => part.trim());
        const len = parts.length;

        const pinCode = parts[3] || '';         // Last part
        const district = parts[0] || '';         // Second-last part (if exists)
        const block = parts[1] || '';         // Second-last part (if exists)
        const post = parts[2] || '';         // Second-last part (if exists)
        const localityParts = parts.slice(4, len);  // Everything else
        const locality = localityParts.join(', ');      // Join with commas
        return { district, locality, pageNum, pinCode, block, post };
      })
      .sort((a, b) => {
        const districtCompare = a.district.localeCompare(b.district, 'ta');
        if (districtCompare !== 0) return districtCompare;

        const blockCompare = a.block.localeCompare(b.block, 'ta');
        if (blockCompare !== 0) return blockCompare;

        const postCompare = a.post.localeCompare(b.post, 'ta');
        if (postCompare !== 0) return postCompare;

        return parseInt(a.pinCode) - parseInt(b.pinCode); // numeric sort for pin code
      });



    // ✅ Remove duplicates based on district + locality
    const uniqueEntries = [];
    const seen = new Set();

    for (const entry of sortedEntries) {

      const key = `${entry.district}||${entry.pinCode}||${entry.block}||${entry.post}||${entry.locality}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueEntries.push(entry);
      }
    }

    const rows = uniqueEntries.map(({ district, locality, pinCode, block, post }) => `
      <tr>
        
        <td style="white-space: nowrap;">${district}</td>
        <td style="white-space: nowrap;">${block}</td>
        <td style="white-space: nowrap;">${post}</td>        
        <td style="white-space: nowrap;">${locality}</td>
        <td style="white-space: nowrap; width: 5%;">${pinCode}</td>
        <td style="white-space: nowrap; width: 5%;"></td>
      </tr>
    `);

    return `
      <h2>அட்டவணை</h2>
      <table class="print-table">
        <thead>
          <tr>
            
            <th style="white-space: nowrap;">மாவட்டம்</th>
            <th style="white-space: nowrap;">வட்டம்</th>
            <th style="white-space: nowrap;">அஞ்சல்</th>
            <th style="white-space: nowrap;">ஊர்</th>
            <th style="white-space: nowrap; width: 5%;">PIN</th>
            <th style="white-space: nowrap; width: 5%;">பக்கம்</th>
          </tr>
        </thead>
        <tbody>
          ${rows.join('\n')}
        </tbody>
      </table>
    `;
  };

  const handlePrint = () => {
    const printWindow = window.open('about:blank', '_blank', 'width=900,height=600');
    const { html: printableHtml, groupPageMap } = generatePrintableTables();
    //const groupIndexHtml = generateGroupIndexHtml(groupPageMap);
    const groupDetailedIndexHtml = generateGroupDetailedIndexHtml(groupPageMap);

    const frontPageHtml = generateFrontPageHtml();
    const fullHtml = frontPageHtml + groupDetailedIndexHtml + printableHtml;




    const initialWidths = [10, 40, 10, 40]; // Widths for existing columns
    const totalInitialWidth = initialWidths.reduce((sum, width) => sum + width, 0);
    const remainingWidth = 100 - totalInitialWidth;
    const extraColWidth = extraCols > 0 ? (remainingWidth / extraCols) : 0;

    const extraColStartIndex = 6; // Fixed columns are 5
    const extraColStyles = Array(extraCols).fill(0).map((_, i) => (
      `th:nth-child(${extraColStartIndex + i}), td:nth-child(${extraColStartIndex + i}) { width: ${extraColWidth}%; }`
    )).join('');

    printWindow.document.write(`
      <html>
        <head>
          <title>${selectedDistrictTamil + '(' + totalItems + ')'}</title>
          <style>
            @page {
              size: ${paperSize} ${orientation};
                margin: 2cm 1cm 1cm 1cm; /* top right bottom left */
              @top-center {
                  content: "நாள்: ${new Date().toLocaleDateString('ta-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    })}";
                  font-family: 'Latha', 'Arial', sans-serif;
                  font-size: 10px;
                  font-weight: bold;
                  color: #555;
                }

                @bottom-center {
                  content: "${selectedDistrictTamil} - பக்கம் " counter(page);
                  font-family: 'Latha', 'Arial', sans-serif;
                  font-size: 15px;
                  color: #555;
                }
            }

            body {
              font-family: 'Latha', 'Arial', sans-serif;
              font-size: 11px;
            }

            table.print-table {
              border-collapse: collapse;
              width: 98%;
              
            }

            table.print-table, table.print-table th, table.print-table td {
              border: 1px solid black;
              padding: 4px 6px;
              text-align: left;
              vertical-align: top;
            }

            table.print-table * {
              border: 1px solid black;
            }

            th {
              background-color: #ccc;
            }

  
            /* Fixed widths for standard columns */
            th:nth-child(1), td:nth-child(1) { width: ${initialWidths[0]}%; }
            th:nth-child(2), td:nth-child(2) { width: ${initialWidths[1]}%; }
            th:nth-child(3), td:nth-child(3) { width: ${initialWidths[2]}%; }
            th:nth-child(4), td:nth-child(4) { width: ${initialWidths[3]}%; }
            th:nth-child(5), td:nth-child(5) { width: ${initialWidths[4]}%; }
            
            /* Dynamically generated widths for extra columns */
            ${extraColStyles}
            .front-page h1, .front-page h2 {
              font-family: 'Latha', 'Arial', sans-serif;
            }

            .front-page h1 {
              font-size: 28px;
              font-weight: bold;
            }

            .front-page h2 {
              font-size: 22px;
              font-weight: normal;
            }

            /* --- Watermark Styles --- */
            .watermark {
                color: #ccc;
                opacity: 0.1;
                font-size: 48px;
                font-weight: bold;
                position: fixed; /* Use 'fixed' for each page */
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(-45deg); /* Center and rotate */
                z-index: -1; /* Place behind other content */
                white-space: nowrap; /* Prevent line breaks */
                pointer-events: none; /* Make it unclickable */
                font-family: 'Latha', 'Arial', sans-serif;
            }
          </style>
        </head>
        <body>
        <div class="watermark">ஶ்ரீ பொன்னாச்சி அம்மன் !</div>
          ${fullHtml}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };


  const groupFamiliesByAddress = (list) => {
    const groups = {};
    list.forEach(family => {
      const subarea = getSubareaNameTamil(family.permanentAddressAreaId, family.permanentSubareaId, areas);

      // Create the address parts array
      const parts = [
        family.permanentAddressDistrict_tamil,
        family.permanentAddressBlock_tamil,
        family.permanentAddressName_tamil,
        String(family.permanentAddressAreaId).split('_')[0],
        subarea,

      ].filter(Boolean); // remove falsy values

      // Remove duplicates while preserving order
      //  / const uniqueParts = [...new Set(parts)];

      let key = parts.join(', ');
      if (!groups[key]) groups[key] = [];
      groups[key].push(family);
    });
    return groups;
  };


  return (
    <div className="general_parent">
      <div className="general_container">
        <div className="general_body">
          <h1>பகுதி வாரியாக குடும்ப தொடர்புகள் அச்சிட</h1>
          <br />
          <div style={{ margin: '1rem 0' }}>
            <label>
              <input
                type="checkbox"
                checked={fetchFullList}
                onChange={(e) => setFetchFullList(e.target.checked)}
              />
              முழு பட்டியலை பெறவும் (அனைத்தும்)
            </label>
          </div>

          <button onClick={fetchAreas} disabled={loadingAreas}>
            {loadingAreas ? 'ஏற்றுகிறது...' : 'முகவரி பட்டியலை ஏற்றவும்'}
          </button>

          <br />

          {districts.length > 0 && !fetchFullList && (
            <form onSubmit={handleSubmit}>
              <div className="auth_element">
                <label>மாவட்டம்:</label>
                <select value={selectedDistrictTamil} onChange={handleDistrictChange} className="auth_select">
                  <option value="">-- மாவட்டம் தேர்ந்தெடுக்கவும் --</option>
                  {districts.map(d => (
                    <option key={d.district_tamil} value={d.district_tamil}>
                      {d.district_tamil_display}
                    </option>
                  ))}
                </select>
              </div>

              {selectedDistrictTamil && blocks.length > 0 && (
                <div className="auth_element">
                  <label>வட்டம்:</label>
                  <select value={selectedBlock} onChange={handleBlockChange} className="auth_select">
                    <option value="">-- வட்டம் தேர்ந்தெடுக்கவும் --</option>
                    {blocks.map(block => (
                      <option key={block} value={block}>{block}</option>
                    ))}
                  </select>
                </div>
              )}

              {selectedBlock && districtIds.length > 0 && (
                <div className="auth_element">
                  <label>அஞ்சல்:</label>
                  <select value={selectedId} onChange={handleIdChange} className="auth_select">
                    <option value="">-- அஞ்சல் தேர்ந்தெடுக்கவும் --</option>
                    {districtIds.map(id => {
                      const area = areas.find(a => a.id === id);
                      return (
                        <option key={id} value={id}>
                          {`${area.name_tamil} (${area.pincode})`}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}

              {/* Show Subareas for the selected Area ID */}
              {selectedId && Array.isArray(subareas) && subareas.length > 0 && (
                <div className="auth_element">
                  <label>ஊர் : </label>
                  <select value={selectedSubareaId} onChange={handleSubareaChange}
                    className="auth_select">
                    <option value="">-- ஊர் தேர்ந்தெடுக்கவும்--</option>
                    {subareas.map(subarea => {
                      const transformedName = subarea.name_tamil
                        ?.split('|')
                        .reverse()
                        .join(',');

                      return (
                        <option key={subarea.id} value={subarea.id}>
                          {transformedName}
                        </option>
                      );
                    })}

                  </select>
                </div>
              )}



            </form>
          )}
          {user?.roles?.includes('SuperUser') && printMode && (
            <div className="print-settings" style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0' }}>
              <h4>🖨️ அச்சு அமைப்புகள் </h4>

              <div className="auth_element">
                <label>காகித அளவு:</label>
                <select value={paperSize} onChange={(e) => setPaperSize(e.target.value)}>
                  <option value="A4">A4</option>
                  <option value="A5">A5</option>
                </select>
              </div>

              <div className="auth_element">
                <label>திசை:</label>
                <select value={orientation} onChange={(e) => setOrientation(e.target.value)}>
                  <option value="portrait">Portrait</option>
                  <option value="landscape">Landscape</option>
                </select>
              </div>

            </div>
          )}


          <button type="button" onClick={handleSubmit}>குடும்ப விவரங்களை பெறவும்</button>
          {user?.roles?.includes('SuperUser') && printMode && (
            <>
              <button type="button" onClick={handlePrint}>🖨️ அச்சிடு</button>
            </>
          )}



          {loading ? (
            <Loading />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: generatePrintableTables().html }} />

          )}

        </div>
      </div>
    </div>
  );
};

export default FamilyAreaWiseListContactPrint;
